import 'dayjs/locale/en'
import { selectLocale } from '../redux/global/selectors'

import { ConfigProvider } from 'antd'
import enLocale from 'antd/lib/locale/en_US'
import esLocale from 'antd/lib/locale/es_ES'
import { useIntl, IntlProvider } from 'react-intl'
import { useEffect } from 'react'
import { connect } from 'react-redux'

import enLanguage from './languages/en.json'
import esLanguage from './languages/es.json'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/es'

dayjs.extend(localizedFormat)

const supportedLocales = {
  en: enLocale,
  es: esLocale,
}

const messages = {
  en: enLanguage,
  es: esLanguage,
}

const AntdProvider = ({ children, locale }) => {
  const { formatMessage } = useIntl()

  const validateMessages = {
    required: formatMessage({ id: 'requiredField' }, { fieldName: '${label}' }),
    types: {
      email: formatMessage({ id: 'formatEmail' }, { fieldName: '${label}' }),
    },
  }

  return (
    <ConfigProvider
      locale={supportedLocales[locale]}
      form={{ validateMessages, requiredMark: 'optional' }}
      // renderEmpty={() => <NoDataEmpty />}
      theme={{
        token: {
          colorPrimary: '#3067f9',
          fontFamily: 'Poppins',
          colorBgLayout: '#f0f2f5',
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

const IntlWrapper = ({ locale, children }) => {
  useEffect(() => {
    if (locale) {
      dayjs.locale(locale)
    }
  }, [locale])

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <AntdProvider locale={locale} children={children} />
    </IntlProvider>
  )
}

const mapStateToProps = (state) => ({
  locale: selectLocale(state),
})

export default connect(mapStateToProps, {})(IntlWrapper)
